import { AddressSearcher, IAddressSearcherData, IAddressSearcherOptions } from '@df/ui/form/address-searcher';

export abstract class AddressSearcherService {
    abstract create(addressSearcherData: IAddressSearcherData, options?: IAddressSearcherOptions): AddressSearcher;
}
